import { render } from "./DeleteButton.vue?vue&type=template&id=7d0403e4"
import script from "./DeleteButton.vue?vue&type=script&lang=js"
export * from "./DeleteButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Auth/DeleteButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d0403e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d0403e4', __exports__)) {
    api.reload('7d0403e4', __exports__)
  }
  
  module.hot.accept("./DeleteButton.vue?vue&type=template&id=7d0403e4", () => {
    api.rerender('7d0403e4', render)
  })

}


export default __exports__